// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"loginPage___1KOC3","loginText":"loginText___32_2L","loginBtn":"loginBtn___3WHjz"};